// اضافه کردن کتابخانه ها به صفحه
import * as React from "react";

import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useSnackbar} from "notistack";
import {createSearchParams, Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {setLoading} from "../redux/loading/actions";
import {convertPrice, handleSetServicesLogo} from "../assets/js/main";
import {
  AppBar,
  Backdrop,
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  IconButton,
  Pagination,
  PaginationItem,
  Radio,
  RadioGroup,
  Slide,
  Tab,
  Tabs,
  Toolbar,
  Typography
} from "@mui/material";
import {ReactComponent as NegativeStore} from "../assets/img/icons/negativeStore.svg";
import {ReactComponent as Wallet} from "../assets/img/icons/wallet.svg";
import NavBar from "../components/NavBar";
import {ArrowBack, ArrowForward, Clear, Close, CreditScore} from "@mui/icons-material";
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en"
import DateObject from "react-date-object";
import HandleFetchData from "../plugin/HandleFetchData";
import {ThemeContext} from "../App";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function OrdersOthers() {
  const {t} = useTranslation()
  const {enqueueSnackbar} = useSnackbar();
  const {fetchData} = HandleFetchData()
  const navigate = useNavigate();
  const theme = React.useContext(ThemeContext)
  const [searchParams] = useSearchParams();
  // استفاده از useLocation در react-router-dom برای گرفتن اطلاعات صفحه جاری
  const location = useLocation();
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const divarIncomId = searchParams.get('state')

  const [tabView, setTabView] = React.useState('پرداخت شده');
  const [listOrder, setListOrder] = React.useState([]);
  const [idOrder, setIdOrder] = React.useState(null)
  const [pageNum, setPageNum] = React.useState(1)
  const [pageSize, setPageSize] = React.useState(12)
  const [hasMore, setHasMore] = React.useState(true)
  const [radio, setRadio] = React.useState("");
  const [creditOrder, setCreditOrder] = React.useState(null)
  const [payMethods, setPayMethods] = React.useState([]);
  const [search, setSearch] = React.useState("");
  const [receiver, setReceiver] = React.useState(null);
  const [fromDate, setFromDate] = React.useState(null);
  const [toDate, setToDate] = React.useState(null);
  const [dialogPaymentMethods, setDialogPaymentMethods] = React.useState(false)
  const [windowWidth, setWindowWidth] = React.useState('');
  const [showSearchItems, setShowSearchItems] = React.useState(false)
  const [dialogDetailsOrder, setDialogDetailsOrder] = React.useState(false)
  const [detailsItem, setDetailsItem] = React.useState({});
  const [_isLoading, _setIsLoading] = React.useState(false);

  React.useEffect(() => {
    getListOrder(pageNum)
  }, [pageNum])

  React.useEffect(() => {
    setWindowWidth(window.innerWidth);
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
      setShowSearchItems(window.innerWidth > 992)
    };
    window.addEventListener('resize', handleWindowResize);


    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [])

  const getListOrder = async (e) => {
    dispatch(setLoading(true))
    setTimeout(async () => {
      let fetch = await fetchData('', 'POST', '/getOrderForMe', {
           "pageSize": pageSize,
           "pageIndex": Number(e),
           "ServiceId": 0,
           "OrderIdFrom": Number(search) || 0,
           "OrderIdTo": Number(search) || 0,
           "PayStatus": 0,
           "OrderStatus": 0,
           "RecieverProvinceId": 0,
           "RecieverCityId": 0,
           "SenderProvinceId": 0,
           "SenderCityId": 0,
           "RecieverName": receiver,
           "FromDate": fromDate ? new DateObject(fromDate).convert(persian, persian_en).format("YYYY-MM-DDThh:mm:ss") : "",
           "ToDate": toDate ? new DateObject(toDate).convert(persian, persian_en).format("YYYY-MM-DDThh:mm:ss") : "",
         },
         "application/vnd.api+json", '', '', ''
      )

      if (fetch?.Data?.length) {
        setListOrder(fetch?.Data)
        // setListOrder([...listOrder, ...fetch?.Data])
      } else if (fetch && fetch?.Status == 500) {
        navigate({
          pathname: "/pageInternalServer",
          search: location?.search
        });
      } else {
        setHasMore(false)
      }
      dispatch(setLoading(false))
    }, 1000)
  }

  const handleDetailsOrder = async (e) => {
    _setIsLoading(true)
    let fetch = await fetchData('nbl', 'GET', `/v1/Order/${e}`, "",
       "application/json", '', 'postex', ''
    )
    // showMessage(fetch?.status)
    if (fetch?.isSuccess) {
      setDialogDetailsOrder(true)
      setDetailsItem(fetch?.data)
    }
    _setIsLoading(false)

  }

  const getPaymentMethods = async (id, credit) => {
    setIdOrder(id)
    setCreditOrder(credit)
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'GET', '/getPaymentMethod', '',
       "application/json", {
         "orderId": String(id),
         "paymentMethodForId": "1"
       }, '', ''
    )

    if (fetch?.Data) {
      setPayMethods(fetch?.Data)
      setDialogPaymentMethods(true)
    }

    dispatch(setLoading(false))
  }

  const payOrder = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'POST', '/payment', {
         "orderId": Number(idOrder),
         "paymentmethod": radio === "Payments.Wallet" ? "" : radio,
         "useRewardPoints": radio === "Payments.Wallet",
         "isForeign": false,
         "reciverPay": false,
         "DivarToken": divarIncomId || null,
         "callBackUrl": `https://${process.env.REACT_APP_SUBDOMAIN}.postex.ir/paymentStatus`
       },
       "application/json", '', '', ''
    )
    if (fetch?.IsSuccess) {
      if (radio === "Payments.Wallet") {
        navigate({
          pathname: "/paymentStatus",
          search: createSearchParams({
            OrderId: fetch?.Data?.orderId,
            code: 0,
            state: fetch?.Data?.divarToken
          })?.toString()
        });
        enqueueSnackbar(fetch?.Message, {
          variant: 'success',
          TransitionProps: {
            direction: 'down',
          },
          anchorOrigin: {
            horizontal: 'center',
            vertical: 'top'
          }
        })
      } else {
        window.open(fetch?.Data, '_self')
      }
    } else if (fetch && fetch?.StatusCode == 500) {
      navigate({
        pathname: "/pageInternalServer",
        search: location?.search
      });
    } else {
      enqueueSnackbar(fetch?.Message, {
        variant: 'error',
        TransitionProps: {
          direction: 'down',
        },
        anchorOrigin: {
          horizontal: 'center',
          vertical: 'top'
        }
      })
    }
    dispatch(setLoading(false))
  }

  const handlerDownload = async (id) => {
    dispatch(setLoading(true))
    var pdfUrl = `https://postex.ir/api/order/getpdfinvoice/${id}`; // Replace with the actual PDF URL
    var myHeaders = new Headers();
    myHeaders.append("token", localStorage.getItem('token'));

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(pdfUrl, requestOptions).then(response => response.blob()).then(blob => {
      // var link = document.createElement('a');
      // link.href = window.URL.createObjectURL(blob);
      // link.download = `${+new Date()}.pdf`;
      // link.click();
      const pdfWindow = window.open();
      const fileURL = URL.createObjectURL(blob);
      if (pdfWindow) {
        pdfWindow.location.href = fileURL;
      }
      dispatch(setLoading(false))
    }).catch(error => {
      console.log('error', error)
      dispatch(setLoading(false))
    });
  }

  const handleSearch = () => {
    getListOrder(1)
  }

  const handleShowSearchItems = () => {
    setShowSearchItems(!showSearchItems)
  }

  return (
     <>
       {selector?.loading?.isLoading &&
          <div className="backdrop-loading">
            <div className="backdrop-bg">
              <div className="loader" style={theme.darkMode ? {backgroundImage: "url('/splash2.gif')"} : {backgroundImage: "url('/splash1.gif')"}}/>
            </div>
          </div>
       }

       {(location.pathname === '/ordersOthers' || location.pathname ===  '/divar/ordersOthers') &&
          <NavBar blue back/>
       }

       <div className="container">
         <div className="orderListPage desktopSection">
           <div className="d-flex align-items-center justify-content-between">
             <h4 className="titleSection">{t("dashboard.order.t17")}</h4>
             <div className="btnGroup_light ml-0 mt-2">
               <button type="button" className="btnFill justify-content-center" onClick={handleShowSearchItems} id="textPrice">
                 <span>{showSearchItems ? t("dashboard.order.t22") : t("dashboard.order.t21")}</span>
               </button>
             </div>
           </div>

           {
              showSearchItems &&
              <div className="search">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-2">
                    <label>{t("dashboard.order.t11")}</label>
                    <input type="text" autoComplete="on" name="receiver"
                           value={receiver} id="receiver"
                           onChange={e => setReceiver(e?.target?.value)}/>
                  </div>
                  <div className="col-12 col-md-6 col-lg-2">
                    <label>{t("dashboard.order.t6")}</label>
                    <input type="text" autoComplete="on" name="search"
                           value={search} id="search"
                           onChange={e => setSearch(e?.target?.value)}/>
                  </div>
                  <div className="col-12 col-md-6 col-lg-2">
                    <label>{t("dashboard.order.t19")}</label>
                    <div className="date-picker">
                      <DatePicker
                         id="setFromDate"
                         calendar={persian}
                         locale={persian_fa}
                         value={fromDate}
                         onChange={e => setFromDate(e)}
                      />
                      <button type="button" onClick={() => setFromDate(null)} id="fromDate">
                        <Clear/>
                      </button>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-2">
                    <label>{t("dashboard.order.t20")}</label>
                    <div className="date-picker">
                      <DatePicker
                         id="setToDate"
                         calendar={persian}
                         locale={persian_fa}
                         value={toDate}
                         onChange={e => setToDate(e)}
                      />
                      <button type="button" onClick={() => setToDate(null)} id="toDate">
                        <Clear/>
                      </button>
                    </div>

                  </div>
                  <div className="col-12 col-md-6 col-lg-2">
                    <div className="_btnGroup_blue mb-0 mt-4">
                      <button className="btnFill justify-content-center" onClick={handleSearch} id="handleSearch">
                        <span>{t("dashboard.order.t21")}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
           }

           <div className="tab">
             <Tabs
                id="tabs"
                value={tabView}
                onChange={(event, newValue) => setTabView(newValue)}
                aria-label="wrapped label tabs example"
             >
               <Tab value="0" label={t("dashboard.order.t2")}/>
               <Tab value="پرداخت شده" label={t("dashboard.order.t3")}/>
               <Tab value="معلق" label={t("dashboard.order.t4")}/>
             </Tabs>
           </div>
           {/*<InfiniteScroll*/}
           {/*   dataLength={listOrder.length}*/}
           {/*   next={() => setPageNum(pageNum + 1)}*/}
           {/*   hasMore={hasMore}*/}
           {/*   style={{overflow: 'hidden'}}>*/}
           <div className="row">
             {
               listOrder?.map((item) => {
                 return (
                    (tabView == 0 || tabView == item?.PaymentStatus) &&
                    <div className="col-12 col-md-6 col-xl-4 d-flex" key={item?.OrderId}>
                      <div className="cardItem">
                        <div className="cardHeader">
                          <div className="align-items-center">
                            <NegativeStore/>
                            {/*<span>{convertDate('1998/02/26')}</span>*/}
                            <span>{item?.OrderDate}</span>
                          </div>
                          <div className="btnGroup_light flex-row m-0">
                            <button type="button" className="btnFill justify-content-center p-2" onClick={() => handlerDownload(item?.OrderId)} id="handlerDownload">
                              <span>{t("dashboard.order.t5")}</span>
                              {/*<Print size="medium"/>*/}
                            </button>
                            <Link to={{pathname: `/orderCancellation`, search: location?.search}} className="btnFill justify-content-center p-2" id="orderCancellation">
                              {/*<a href="https://app.didar.me/customer/form/ee910b76-7ac2-4c32-aa9e-445816cedd66" className="btnFill justify-content-center p-2" id="orderCancellation">*/}
                              <span>{t("dashboard.order.t23")}</span>
                              {/*</a>*/}
                              {/*<Print size="medium"/>*/}
                            </Link>
                          </div>

                        </div>
                        <div className="cardBody">
                          <div className="title">
                            <div>
                              <h6>{t("dashboard.order.t6")}</h6>
                              <h6 className="orderNumber">{item?.OrderId}</h6>
                            </div>
                            <p className={item?.PaymentStatus == 'معلق' ? 'suspended' : 'paid'}>{t("dashboard.order.t7")}: {item?.PaymentStatus}</p>
                          </div>
                          <div className="category">
                            <div>
                              <img src={handleSetServicesLogo(item?.CategoryName)} alt={item?.CategoryName} loading="lazy"/>
                              <p>{item?.CategoryName}</p>
                            </div>
                            <div className="btnGroup_light m-0">
                              <button className="btnEmpty justify-content-center" onClick={() => handleDetailsOrder(item?.OrderId)}>
                                <span>{t("dashboard.order.t26")}</span>
                              </button>
                            </div>
                          </div>
                          <div className="desc">
                            <p>{t("dashboard.order.t8")}: {item?.OrderStatus}</p>
                            <p>{t("dashboard.order.t9")}: {item?.ShipmentsState}</p>
                            <p>{t("dashboard.order.t10")}: {item?.strBillingAddress}</p>
                          </div>
                          <Divider/>
                          <div className="payment">
                            <div className="price">
                              <Wallet/>
                              <span> {t("dashboard.order.t12")}: {convertPrice(item?.FactorPrice)} {t("dashboard.order.t13")} </span>
                            </div>

                            {
                              item?.PaymentStatus == 'معلق' ? <>
                                   <div className="btnGroup_yellow">
                                     <button type="button" disabled={selector?.loading?.isLoading} className="btnFill justify-content-center"
                                             onClick={() => getPaymentMethods(item?.OrderId, item?.FactorPrice)}
                                             id="getPaymentMethods"
                                     >
                                       {
                                         (selector?.loading?.isLoading && item?.OrderId == idOrder) ?
                                            <Box sx={{display: 'flex'}}>
                                              <CircularProgress size={20}/>
                                            </Box>
                                            :
                                            <span>{t("dashboard.order.t14")}</span>
                                       }
                                     </button>
                                   </div>
                                 </>
                                 :
                                 <>
                                   <div className="_btnGroup_light m-0">
                                     <button type="button" disabled className="btnEmpty justify-content-center">
                                       <span>{t("dashboard.order.t3")}</span>
                                     </button>
                                   </div>
                                 </>
                            }
                          </div>

                        </div>
                      </div>
                    </div>
                 )
               })
             }

             {
                !listOrder?.length && <div className="notFindMessage">
                  <img src={require('./../assets/img/vector/1.png')} alt="vector" loading="lazy"/>
                  <p>{t("error.t2")}</p>
                </div>
             }
           </div>
           {/*</InfiniteScroll>*/}

           {listOrder?.length &&
              <div className="paginate">
                <Pagination
                   count={Math.ceil(listOrder[0]?.TotalCount / pageSize)}
                   page={pageNum}
                   onChange={(event, value) => setPageNum(value)}
                   renderItem={(item) => (
                      <PaginationItem
                         slots={{previous: ArrowBack, next: ArrowForward}}
                         {...item}
                      />
                   )}
                />
              </div>
           }

         </div>
       </div>

       <Dialog
          open={dialogPaymentMethods}
          onClose={() => setDialogPaymentMethods(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
       >
         <DialogTitle id="alert-dialog-title">
           <div className="icon">
             <CreditScore/>
           </div>
         </DialogTitle>

         <DialogContent>

           <h4>{t("dashboard.order.t15")}</h4>

           <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              value={radio}
              onChange={(e) => setRadio(e.target.value)}
           >
             {
               payMethods?.PaymentMethods?.map((item, index) =>
                  item?.Name !== "بانک سامان" && <FormControlLabel value={item?.PaymentMethodSystemName} control={<Radio/>}
                                                                   label={item?.Name + ' ' + `${item?.PaymentMethodSystemName === "Payments.Wallet"
                                                                      ? `( ${(payMethods?.RewardPointsBalance ?
                                                                         convertPrice(payMethods?.RewardPointsBalance) : 0) + ' ' + t("singleOrder.invoice.t14")} )` : ''}`}/>
               )
             }

           </RadioGroup>

         </DialogContent>

         <DialogActions className="_btnGroup_blue">
           <button className="btnEmpty justify-content-center" onClick={() => setDialogPaymentMethods(false)} id="closeDialogPaymentMethods">{t("dashboard.order.t16")}</button>
           <button className="btnFill justify-content-center" disabled={selector?.loading?.isLoading} onClick={() => payOrder()} id="payOrder">
             {
               selector?.loading?.isLoading ?
                  <Box sx={{display: 'flex'}}>
                    <CircularProgress size={20}/>
                  </Box>
                  :
                  t("dashboard.order.t14")
             }

           </button>
         </DialogActions>
       </Dialog>

       <Dialog
          fullScreen
          open={dialogDetailsOrder}
          onClose={() => setDialogDetailsOrder(false)}
          TransitionComponent={Transition}
          className="full-screen-dialog"
       >
         <AppBar sx={{position: 'relative'}}>
           <Toolbar>
             <IconButton
                edge="start"
                color="inherit"
                onClick={() => setDialogDetailsOrder(false)}
                aria-label="close"
             >
               <Close/>
             </IconButton>
             <Typography sx={{ml: 2, flex: 1}} variant="h6" component="div">
               {t("dashboard.order.t59")}
             </Typography>
           </Toolbar>
         </AppBar>

         <div className="body-calculate-dialog">
           <div className="container">

             <div className="item-details">
               <div>
                 <div className="bg-item">
                   <div className="item">
                     <span>{t("dashboard.order.t27")}: </span>
                     <p>{detailsItem?.orderId}</p>
                   </div>
                   <div className="item">
                     <span>{t("dashboard.order.t28")}: </span>
                     <p>{detailsItem?.shipmentId}</p>
                   </div>
                   <div className="item">
                     <span>{t("dashboard.order.t29")}: </span>
                     <p className="order-status">{detailsItem?.orderStatus}</p>
                   </div>
                   <div className="item">
                     <span>{t("dashboard.order.t30")}: </span>
                     <p className="payment-status">{detailsItem?.paymentStatus}</p>
                   </div>
                 </div>

                 <div className="d-flex align-items-center justify-content-center p-3 ">
                   <span>{t("dashboard.order.t31")}: </span>
                   <p className="tracking-number">{detailsItem?.trackingNumber || t("dashboard.order.t62")}</p>
                 </div>
               </div>
             </div>

             <h4>{t("dashboard.order.t10")}</h4>

             <div className="item-details">
               <div className="items">
                 <span>{t("dashboard.order.t32")}</span>
                 <div className="bg-item">
                   <p>{detailsItem?.createDateTime_Sh}</p>
                 </div>
               </div>


               <div className="items">
                 <span>{t("dashboard.order.t36")}</span>
                 <div className="bg-item">
                   <p>{detailsItem?.senderFirstName + '  ' + detailsItem?.senderLastName}</p>
                 </div>
               </div>
             </div>

             <div className="item-details">
               <div className="items">
                 <span>{t("dashboard.order.t38")}</span>
                 <div className="bg-item">
                   <p>{detailsItem?.senderPhoneNumber}</p>
                 </div>
               </div>

               <div className="items">
                 <span>{t("dashboard.order.t33")}</span>
                 <div className="bg-item">
                   <p>{detailsItem?.senderState + ' - ' + detailsItem?.senderCity}</p>
                 </div>
               </div>
             </div>

             <div className="item-details">
               <div className="items">
                 <span>{t("dashboard.order.t35")}</span>
                 <div className="bg-item">
                   <p>{detailsItem?.snederAddress}</p>
                 </div>
               </div>
             </div>


             <h4>{t("dashboard.order.t11")}</h4>

             <div className="item-details">
               <div className="items">
                 <span>{t("dashboard.order.t39")}</span>
                 <div className="bg-item">
                   <p>{detailsItem?.receiverStateName + ' - ' + detailsItem?.receiverCityName}</p>
                 </div>
               </div>


               <div className="items">
                 <span>{t("dashboard.order.t42")}</span>
                 <div className="bg-item">
                   <p>{detailsItem?.receiverFirstName + '  ' + detailsItem?.receiverLastName}</p>
                 </div>
               </div>
             </div>

             <div className="item-details">
               <div className="items">
                 <span>{t("dashboard.order.t41")}</span>
                 <div className="bg-item">
                   <p>{detailsItem?.receiverAdress}</p>
                 </div>
               </div>
             </div>


             <h4>{t("dashboard.order.t60")}</h4>

             <div className="item-details">
               <div className="items">
                 <span>{t("dashboard.order.t44")}</span>
                 <div className="bg-item">
                   <p>{detailsItem?.goodsType}</p>
                 </div>
               </div>


               <div className="items">
                 <span>{t("dashboard.order.t45")}</span>
                 <div className="bg-item">
                   <p>{convertPrice(detailsItem?.exactWeight)}</p>
                 </div>
               </div>
             </div>

             <div className="item-details">
               <div className="items">
                 <span>{t("dashboard.order.t46")}</span>
                 <div className="bg-item">
                   <p>{detailsItem?.insuranceValue}</p>
                 </div>
               </div>
               <div className="items">
                 <span>{t("dashboard.order.t48")}</span>
                 <div className="bg-item">
                   <p>{convertPrice(detailsItem?.approximateValue)}</p>
                 </div>
               </div>
             </div>

             <div className="item-details">
               <div className="items">
                 <span>{t("dashboard.order.t51")}</span>
                 <div className="bg-item">
                   <p className="d-flex"><span> cm </span> {detailsItem?.length} </p>
                 </div>
               </div>
               <div className="items">
                 <span>{t("dashboard.order.t52")}</span>
                 <div className="bg-item">
                   <p className="d-flex"><span> cm </span> {detailsItem?.width} </p>
                 </div>
               </div>
               <div className="items">
                 <span>{t("dashboard.order.t53")}</span>
                 <div className="bg-item">
                   <p className="d-flex"><span> cm </span> {detailsItem?.height} </p>
                 </div>
               </div>
             </div>

             <div className="item-details">
               <div className="items">
                 <span>{t("dashboard.order.t61")}</span>
                 <div className="bg-item">
                   <div className="item">
                     <span>{t("dashboard.order.t50")} <b>{detailsItem?.cartonValue}</b></span>
                   </div>
                   <div className="item">
                     <span>{t("dashboard.order.t54")} <b>{detailsItem?.printLogoValue}</b></span>
                   </div>
                   <div className="item">
                     <span>{t("dashboard.order.t55")} <b>{detailsItem?.needCollector === "True" ? t("dashboard.order.t57") : t("dashboard.order.t58")}</b></span>
                   </div>
                   <div className="item">
                     <span>{t("dashboard.order.t56")} <b>{detailsItem?.needDistributer === "True" ? t("dashboard.order.t57") : t("dashboard.order.t58")}</b></span>
                   </div>


                 </div>
               </div>
             </div>

           </div>
         </div>
       </Dialog>
     </>
  )
}
